<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" size="mini">
      <el-form-item label="卡券名称: " style="margin-left: 20px">
        <el-input
          v-model="selectForm.msg"
          placeholder="请输入"
          style="width: 180px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="卡号: " style="margin-left: 20px">
        <el-input
          v-model="selectForm.vipNumber"
          placeholder="请输入"
          style="width: 180px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号: " style="margin-left: 20px">
        <el-input
          v-model="selectForm.userPhone"
          placeholder="请输入"
          style="width: 180px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="收货地址: " style="margin-left: 20px">
        <el-input
          v-model="selectForm.adressDes"
          placeholder="请输入"
          style="width: 180px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="核销状态: " style="margin: 0 20px">
        <el-select
          style="width: 180px"
          v-model="selectForm.cardStatus"
          placeholder="请选择"
          clearable
        >
          <div v-for="item in hexiaoStatus" :key="item.id">
            <el-option
              :label="item.value"
              :value="item.id + ''"
              :key="item.id"
            ></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="发货状态: " style="margin: 0 10px">
        <el-select
          style="width: 180px"
          v-model="selectForm.fahuoStatus"
          placeholder="请选择"
          clearable
        >
          <div v-for="item in fahuoStatus" :key="item.id">
            <el-option
              :label="item.value"
              :value="item.id + ''"
              :key="item.id"
            ></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="激活状态: " style="margin: 0 30px">
        <el-select
          style="width: 180px"
          v-model="selectForm.jihuoStatus"
          placeholder="请选择"
          clearable
        >
          <div v-for="item in jihuoStatus" :key="item.id">
            <el-option
              :label="item.value"
              :value="item.id + ''"
              :key="item.id"
            ></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectAllBtn">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addSkuDialog">创建卡券</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin: 0 0 10px 0px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
          >导出 Excel（数量/ {{ dataList.length }}条）</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-upload
          ref="upload"
          action="/"
          :show-file-list="false"
          :on-change="importExcel"
          :auto-upload="false"
        >
          <el-button slot="trigger" icon="el-icon-upload" type="primary">
            批量导入物流单号
          </el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-upload
          ref="upload"
          action="/"
          :show-file-list="false"
          :on-change="importExcelCard"
          :auto-upload="false"
        >
          <el-button slot="trigger" icon="el-icon-upload" type="primary">
            批量导入卡券
          </el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="text">当前查询数据: {{ totalCount }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="text">已核销已发货: {{ sum1 }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="text">已核销未发货: {{ sum2 }}</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height: 70%">
      <el-table
        border
        :data="dataList"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-text="正在加载中"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="是否激活" align="center" width="80">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.jihuoStatus == 1"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="jihuoStatusChange(scope.row, $event)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="核销状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.cardStatus === '1'"
              >已核销</el-tag
            >
            <el-tag type="danger" v-else>未核销</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="卡券名称" min-width="180" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.msg ? scope.row.msg : "暂无" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="卡券规格描述" min-width="200" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.message ? scope.row.message : "/" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="卡号" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.vipNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="卡密" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.password }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="发货状态(线上邮寄情况)"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.logisticsNumber ? "已发货" : "未发货" }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="邮寄地区" align="center" width="250">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>
                {{ scope.row.adress ? scope.row.adress : "/" }}
              </p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium" class="text-hide">{{
                  scope.row.adress ? scope.row.adress : "/"
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column> -->
        <!--   <el-table-column label="邮寄详细地址" align="center" width="250">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>
                {{ scope.row.adressDes ? scope.row.adressDes : "/" }}
              </p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium" class="text-hide">{{
                  scope.row.adressDes ? scope.row.adressDes : "/"
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column> -->

        <el-table-column label="创建时间" min-width="180" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime ? scope.row.createTime : "/" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="ejectaddCardCoupon(scope.row)"
              class="handleBtn"
              type="primary"
              >卡券详情</el-button
            >
            <el-button
              size="mini"
              @click="ejectFahuo(scope.row)"
              class="handleBtn"
              type="success"
              v-if="
                scope.row.adress !== '门店自提用户' &&
                scope.row.adressDes !== ''
              "
              >发货详情</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deleteCardCoupon(scope.row)"
              :disabled="role_id == 1"
              class="handleBtn"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="currentChange"
        :page-sizes="[50, 100, 500, 1000, 2000]"
        :page-size="50"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="selectForm.pageSize"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <!-- 核销表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <div style="height: 400px; overflow-y: auto">
        <el-form :model="form">
          <el-form-item label="卡券名称" :label-width="formLabelWidth">
            <el-input
              v-model="form.msg"
              auto-complete="off"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="卡券规格描述" :label-width="formLabelWidth">
            <el-input
              disabled
              v-model="form.message"
              auto-complete="off"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="卡号" :label-width="formLabelWidth">
            <el-input
              v-model="form.vipNumber"
              auto-complete="off"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="卡密" :label-width="formLabelWidth">
            <el-input
              v-model="form.password"
              auto-complete="off"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="核销状态:" :label-width="formLabelWidth">
            <el-select v-model="form.cardStatus" placeholder="请选择核销状态">
              <div v-for="item in hexiaoStatus" :key="item.id">
                <el-option
                  :label="item.value"
                  :value="item.id + ''"
                ></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="领取人姓名" :label-width="formLabelWidth">
            <el-input v-model="form.userName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="领取人手机号" :label-width="formLabelWidth">
            <el-input v-model="form.userPhone" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="线下领取门店" :label-width="formLabelWidth">
            <el-input v-model="form.storeName"></el-input>
          </el-form-item>
          <el-form-item label="线下门店地址" :label-width="formLabelWidth">
            <el-input
              v-model="form.storeAdress"
              auto-complete="off"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="预约自提时间" :label-width="formLabelWidth">
            <el-input v-model="form.zitiTime"></el-input>
          </el-form-item>
          <el-form-item label="卡券核销时间" :label-width="formLabelWidth">
            <el-input
              v-model="form.writeOffTime"
              disabled
              placeholder="保存后自动生成"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="邮寄地区" :label-width="formLabelWidth">
          <el-input
            v-model="form.adress"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮寄详细地址" :label-width="formLabelWidth">
          <el-input
            v-model="form.adressDes"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item> -->
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updataBtn">修 改</el-button>
      </div>
    </el-dialog>

    <!-- 发货表单 -->
    <el-dialog
      title="发货"
      :visible.sync="dialogFormVisible2"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="卡券名称" :label-width="formLabelWidth">
          <el-input v-model="form.msg" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="卡券规格描述" :label-width="formLabelWidth">
          <el-input
            disabled
            v-model="form.message"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="卡号" :label-width="formLabelWidth">
          <el-input
            v-model="form.vipNumber"
            auto-complete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="卡密" :label-width="formLabelWidth">
          <el-input
            v-model="form.password"
            auto-complete="off"
            disabled
          ></el-input>
        </el-form-item> -->
        <el-form-item label="领取人姓名" :label-width="formLabelWidth">
          <el-input v-model="form.userName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="领取人手机号" :label-width="formLabelWidth">
          <el-input v-model="form.userPhone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮寄地区" :label-width="formLabelWidth">
          <el-input
            v-model="form.adress"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮寄详细地址" :label-width="formLabelWidth">
          <el-input
            v-model="form.adressDes"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="预约发货时间" :label-width="formLabelWidth">
          <el-input v-model="form.zitiTime"></el-input>
        </el-form-item>
        <el-form-item
          label="物流单号(线上邮寄时填写)"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.logisticsNumber"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="updataBtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 批量生成卡券弹窗 -->
    <el-dialog title="批量生成卡券" :visible.sync="couponVisible">
      <div style="margin: 20px; color: red">
        生成规则:
        XXXX(前位字符自己输入)+XXXX(设置一个数字起点,按数递增)
      </div>
      <el-form :model="skuForm">
        <el-form-item label="卡号前字符" :label-width="formLabelWidth">
          <el-input
            v-model="addCouponForm.firstVipNumber"
            auto-complete="off"
            placeholder="通常为合作商字母或数字标识"
          ></el-input>
        </el-form-item>
        <el-form-item label="后四位起点" :label-width="formLabelWidth">
          <el-input
            v-model="addCouponForm.lastVipNumber"
            auto-complete="off"
            placeholder="通常为序号标识,写入生成的起点数字(4位数以内)"
            maxlength="4"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="卡券名称" :label-width="formLabelWidth">
          <el-input v-model="addCouponForm.msg" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="卡券规格描述" :label-width="formLabelWidth">
          <el-input
            v-model="addCouponForm.message"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="生成数量" :label-width="formLabelWidth">
          <el-input
            placeholder="单次数量小于2000"
            v-model="addCouponForm.num"
            auto-complete="off"
            type="number"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="couponVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCouponBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  addCardCoupon,
  updateCardCoupon,
  selectCardCoupon,
  deleteCardCoupon,
  updateJihuoStatus,
  updateSendState,
  addCardCouponCardList,
  selectSum,
} from "@/services/cardCoupon";
import XLSX from "xlsx";
export default {
  created() {
    this.role_id = this.$store.state.supUser.role_id;
    this.selectAll();
    this.selectSumFun();
  },

  data() {
    return {
      role_id: "",
      sum1: "",
      sum2: "",
      selectForm: {
        msg: "",
        vipNumber: "",
        userPhone: "",
        cardStatus: "",
        adressDes: "",
        jihuoStatus: "",
        pageSize: 1,
        pageNumber: 50,
      }, //筛选条件
      totalCount: 0,
      downloadLoading: false,
      addCouponForm: {}, //新增卡券参数
      status: 0,
      goodsTitle: "",
      tableData: [],
      categoryId: "",
      productName: "",
      // 一级分类 二级分类 商品
      select_one_id: "",
      select_two_id: "",
      hexiaoStatus: [
        { id: 0, value: "未核销" },
        { id: 1, value: "已核销" },
      ],
      fahuoStatus: [
        { id: 0, value: "未发货" },
        { id: 1, value: "已发货" },
      ],
      jihuoStatus: [
        { id: 0, value: "未激活" },
        { id: 1, value: "已激活" },
      ],
      dataList: [],
      dialogFormVisible: false,
      dialogFormVisible2: false,
      formLabelWidth: "120px",
      fileList: [],
      loading: false,
      form: {},
      inpitTypeName: "",
      headerImg: [],
      detailsImg: [],
      sku: [], //sku数组
      skuActive: "",
      skuForm: {
        //新增sku
        productId: "",
        price: "",
        sku: "",
      },
      couponVisible: false,
    };
  },
  methods: {
    /* shu量统计 */
    selectSumFun() {
      selectSum().then((res) => {
        console.log(res);
        this.sum1 = res.sum1;
        this.sum2 = res.sum2;
      });
    },
    selectAll() {
      (this.loading = true),
        selectCardCoupon({ ...this.selectForm })
          .then((resp) => {
            console.log(resp);
            if (resp.code === 200) {
              setTimeout(() => {
                this.loading = false;
              }, 600);
              this.dataList = resp.rows;
              this.totalCount = resp.total;
            } else {
              setTimeout(() => {
                this.loading = false;
              }, 600);
              this.$message.error("网络错误,请稍后重试!");
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("服务器异常,请联系技术人员!");
          });
    },
    selectAllBtn() {
      this.selectForm.pageSize = 1;
      this.selectAll();
    },
    // 切换每页数量
    handleSizeChange(e) {
      console.log(e);
      this.selectForm.pageNumber = e;
      this.selectForm.pageSize = 1;
      this.selectAll();
    },
    // 分页页码
    currentChange(e) {
      console.log(e);
      this.selectForm.pageSize = e;
      this.selectAll();
    },
    /* 新增 */
    addSkuDialog() {
      if (this.totalCount >= 50000) {
        return this.$message.error("当前数据已达上限,服务器资源错误");
      }
      this.couponVisible = true;
      this.addCouponForm = {};
    },
    addCouponBtn() {
      if (
        this.addCouponForm.lastVipNumber === undefined ||
        this.addCouponForm.lastVipNumber.length > 4
      ) {
        return this.$message.error("卡号后四位请输入4位数以内的数字");
      }
      console.log(this.addCouponForm.firstVipNumber);
      if (this.addCouponForm.firstVipNumber === undefined) {
        return this.$message.error("卡号前位字符");
      }
      if (
        this.addCouponForm.lastVipNumber === undefined ||
        this.addCouponForm.lastVipNumber.length > 4
      ) {
        return this.$message.error("卡号后四位请输入4位数以内的数字");
      }
      if (this.addCouponForm.num > 0 && this.addCouponForm.num < 2000) {
        this.couponVisible = false;
        this.loading = true;
        //生成卡号与卡密
        addCardCoupon(this.addCouponForm).then((resp) => {
          console.log(resp);
          if (resp.code == 200) {
            this.$message.success("新增成功");
          } else {
            this.$message.error("新增失败");
          }
          this.selectAll();
        });
      } else {
        this.$message.error("请输入合法的数量");
      }
    },

    /* 修改 */
    ejectaddCardCoupon(row) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "卡券详情";
      this.form = JSON.parse(JSON.stringify(row));
    },
    ejectFahuo(row) {
      this.dialogFormVisible2 = true;
      this.form = JSON.parse(JSON.stringify(row));
    },
    updataBtn() {
      updateCardCoupon(this.form).then((resp) => {
        console.log(resp);
        if (resp.code == 200) {
          this.$message.success("操作成功");
          this.dialogFormVisible = false;
          this.dialogFormVisible2 = false;
          this.selectAll();
          this.selectSumFun();
        } else {
          this.$message.error("操作失败");
        }
      });
    },
    /* 激活卡券 */
    jihuoStatusChange(row, val) {
      if (this.role_id == 1) {
        this.$message({
          type: "error",
          message: "子账号没有激活权限",
          offset: 100,
        });
        return;
      }
      console.log("是否激活卡券?", row, val);
      this.$confirm(
        `是否确定激活卡券${val == "1" ? "激活" : "取消"}激活？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          if (val === true) {
            row.jihuoStatus = "1";
          } else {
            row.jihuoStatus = "0";
          }
          updateJihuoStatus({ id: row.id, jihuoStatus: row.jihuoStatus }).then(
            (res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "设置成功",
                  offset: 100,
                });
                if (val) {
                  row.jihuoStatus = "1";
                } else {
                  row.jihuoStatus = "0";
                }
              } else {
                this.$message({
                  type: "error",
                  message: "激活失败",
                  offset: 100,
                });
              }
            }
          );
        })
        .catch(() => {
          console.log("取消", val);
        });
    },
    /* 删除 */
    deleteCardCoupon(row) {
      console.log("删除===", row);
      this.$confirm("此操作将永久删除该卡券, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteCardCoupon(row).then((resp) => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.selectAll();
            this.selectSumFun();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../../vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "id",
          "卡券名称",
          "卡券规格描述",
          "卡号",
          "卡密",
          "是否激活(0未激活,1激活)",
          "领取人姓名",
          "领取人手机号",
          "线下领取门店",
          "自提时间",
          "邮寄地址",
          "邮寄详细地址",
          "物流单号",
          "核销状态(0未核销,1已核销)",
          "核销时间",
        ];
        const filterVal = [
          "id",
          "msg",
          "message",
          "vipNumber",
          "password",
          "jihuoStatus",
          "userName",
          "userPhone",
          "storeName",
          "zitiTime",
          "adress",
          "adressDes",
          "logisticsNumber",
          "cardStatus",
          "writeOffTime",
        ];
        const list = this.dataList;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "卡券列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },

    /*  导入物流单号 */
    importExcel(file) {
      const types = file.name.split(".")[1];
      const fileType = ["xlsx", "xlm", "xls"].some((item) => item === types);
      if (!fileType) {
        alert("格式错误！请重新选择");
        return;
      }
      this.file2Xce(file).then((tabJson) => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson;
          let dateXlx = tabJson[0].sheet; //导入的数据数组
          // console.log("------导入的数据为", this.xlsxJson, dateXlx);
          // 一项项导入数据
          dateXlx
            .map((item) => {
              return {
                ...item,
                物流单号: item?.["物流单号"] || null,
              };
            })
            .forEach((item) => {
              // console.log("item", item["物流单号"]);
              if (item["物流单号"] !== null) {
                console.log('item["物流单号"]', item["物流单号"]);
                updateSendState({
                  id: item.id,
                  logisticsNumber: item["物流单号"],
                }).then(() => {
                  // console.log(res);
                  this.selectAll();
                  this.selectSumFun();
                });
              } else {
                this.$message.error("请检查表格数据是否完整");
              }
            });
        }
      });
    },
    file2Xce(file) {
      // return new Promise(function (resolve, reject) {
      return new Promise(function (resolve) {
        const reader = new FileReader();
        reader.onload = function (e) {
          const data = e.target.result;
          this.wb = XLSX.read(data, {
            type: "binary",
          });
          const result = [];
          this.wb.SheetNames.forEach((sheetName) => {
            result.push({
              sheetName: sheetName,
              sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName]),
            });
          });
          resolve(result);
        };
        reader.readAsBinaryString(file.raw);
        // reader.readAsBinaryString(file) // 传统input方法
      });
    },

    /*  导入卡号卡密 */
    importExcelCard(file) {
      const types = file.name.split(".")[1];
      const fileType = ["xlsx", "xlm", "xls"].some((item) => item === types);
      if (!fileType) {
        alert("格式错误！请重新选择");
        return;
      }
      this.file2Xce(file).then((tabJson) => {
        if (tabJson && tabJson.length > 0) {
          this.xlsxJson = tabJson;
          let dateXlx = tabJson[0].sheet;
          // 一项项导入数据
          dateXlx
            .map((item) => {
              return {
                ...item,
                // 物流单号: item?.["物流单号"] || null,
              };
            })
            .forEach((item) => {
              // console.log("item", item);
              if (
                item["卡券名称"] &&
                item["卡券规格描述"] &&
                item["卡号"] &&
                item["卡密"]
              ) {
                addCardCouponCardList({
                  msg: item["卡券名称"],
                  message: item["卡券规格描述"],
                  vipNumber: item["卡号"],
                  password: item["卡密"],
                }).then(() => {
                  this.selectAll();
                  this.selectSumFun();
                });
              } else {
                this.$message.error("请检查表格数据是否完整");
              }
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.goodsTitle:hover {
  cursor: pointer;
}
.upload-demo {
  margin: 20px;
}
.sku {
  border: 1px dotted rgb(189, 189, 189);
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
}
.sku > div {
  margin-right: 10px;
  padding: 10px 20px;
  background: rgb(245, 138, 44);
  border-radius: 10px;
  color: white;
}
.sku > div:hover {
  cursor: pointer;
}
.skuBg {
  background: rgb(254, 66, 3) !important;
}
.handleBtn {
  margin: 5px;
}
</style>
